import {useMutation} from 'react-query';
import {client} from './ApiClient';
import {SnippetAuth} from "./SnippetAuth";

// The cart comes from the snippet's session (or cart Uid), so no cart id is sent.
const setCustomerToCart = ({urls, auth, customerUid}: {urls: any; auth: SnippetAuth | undefined; customerUid: string}) => {
	if (!auth)
		return Promise.reject('A snippet session key is required.')

	return client(urls.LoyaltyEngineApiUrl, 'v5/snippets/carts/commands/setcustomer', {
		...auth,
		body: {
			Uid: customerUid,
		}
	});
}

export default function useSetCustomerToCart() {
	// @ts-ignore
	return useMutation(setCustomerToCart)
}
